import Account from "@/helper/AccountHelper.js";
import ThemeHelper from "@/helper/ThemeHelper.js";

export default {
    computed: {
        tier: function () {
            return this.$store.state.tier;
        },
        theme: function () {
            return this.$store.state.theme;
        },
        isAmbassador: function () {
            return this.$store.state.isAmbassador;
        }
    },
    data: function () {
        return {
            isAccountLoaded: false,
            isLogin: false,
            user: {},
            profile: {},
            point: 0,
            pointDate: 0
        };
    },
    created: function () {
        Account.loginStatus().then((status) => {
            this.isLogin = status;
            this.user = Account.getCacheUser();
            this.profile = Account.getCacheProfile();
            this.point = Account.getCachePoint();
            this.pointDate = Account.getCachePointUpdateDate();
        }).finally(() => {
            this.isAccountLoaded = true;
            if (this.profile) {
                var detail = Account.getCacheUserDetail();
                this.updateTheme(detail);
            }
        });
    },
    mounted: function () {
        this.getAccountInitiated();
    },
    methods: {
        getAccountInitiated: function () {
            if (this.isAccountLoaded) {
                if (typeof this.accountInitiated == 'function') {
                    this.accountInitiated();
                }
            } else {
                setTimeout(() => {
                    this.getAccountInitiated();
                }, 250);
            }
        },
        getToken: function () {
            return Account.getToken();
        },
        //point
        getUserPoint: function () {
            this.point = Account.getCachePoint();
        },
        updateUserPoint: function (updatedPoint) {
            if (!updatedPoint) return;

            Account.updatePoint(updatedPoint);
            this.getUserPoint();
        },
        getPictureLine: function (){
            var userCache = Account.getCacheUser();
            if(userCache && userCache.line){
                this.isLine = true;
                this.linePicture = userCache.line.pictureUrl;
            }
            return this.linePicture;
        },
        updateTheme: function (detail) {
            if (!detail) return;
            // use helper function to get theme, tier, and ambassador
            var themeInfo = ThemeHelper.getThemeFromTier(detail);

            this.$store.commit('changeTheme', themeInfo.theme);
            this.$store.commit('changeTier', themeInfo.tier);
            this.$store.commit('changeIsAmbassador', themeInfo.isAmbassador);
        }
    }
}
